var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SourcesCopyToSelect'),_c('CopyToInvite',{attrs:{"inviteCompleteCb":_vm.inviteCompleteCb}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }